<!-- 量化回测交易参数 -->
<template>
    <div class="collapse" >
        <p class="title">
            · 交易参数
        </p>
        <div class="yz-list parameter">
            <van-row gutter="8">
                <van-col span="24" class="showParameterAll_animation">
                    <div class="li">
                        <p class="par-classify">基础 I</p>

                        <ul class="par-ul">
                            <li class="par-ul_li">
                                <p class="par-ul_label">初始化资金</p>

                                <p class="par-ul_content">{{ mockHcInfo.startMoney || '--' }}元</p>
                            </li>

                            <li class="par-ul_li">
                                <p class="par-ul_label">持股上限</p>

                                <p class="par-ul_content">{{ mockHcInfo.posLimit || '--' }}只</p>
                            </li>
                            <li class="par-ul_li">
                                <p class="par-ul_label">持股周期</p>

                                <p class="par-ul_content">
                                    <!-- <span v-for="(item, index) in (mockHcInfo.chigu_cycle ? String(mockHcInfo.chigu_cycle).split(',') : [])" :key="index">{{ item
                                        }}天</span> -->
                                        <span>{{ datailObj.ts_chigu || '--' }}天</span>
                                </p>
                            </li>
                        </ul>
                    </div>
                </van-col>

                <van-col span="24" class="showParameterAll_animation">
                    <div class="li">
                        <p class="par-classify">买入 I</p>

                        <ul class="par-ul">
                            <li class="par-ul_li">
                                <p class="par-ul_label">买入时机</p>

                                <p class="par-ul_content">次日开盘买入</p>
                            </li>

                            <li class="par-ul_li">
                                <p class="par-ul_label">单日买入</p>

                                <p class="par-ul_content">{{ mockHcInfo.buyLimit || '--' }}只</p>
                            </li>

                            <li class="par-ul_li">
                                <p class="par-ul_label">买入顺序</p>

                                <p class="par-ul_content">
                                    <span v-if="mockHcInfo.sortKind == 0">成交额</span>
                                    <span v-if="mockHcInfo.sortKind == 1">涨跌幅</span>
                                    <span v-if="mockHcInfo.sortKind == 2">换手率</span>
                                    <span v-if="mockHcInfo.sortKind == 3">量比</span>
                                    <span v-if="mockHcInfo.sortKind == 4">总市值</span>
                                    <span v-if="mockHcInfo.sortKind == 5">流通市值</span>
                                    <span v-if="mockHcInfo.sortKind == 6">市盈率TTM</span>
                                    <span v-if="mockHcInfo.sortKind == 7">振幅</span>
                                    <span v-if="mockHcInfo.sortDirection == 0">从大到小</span>
                                    <span v-if="mockHcInfo.sortDirection == 1">从小到大</span>
                                </p>
                            </li>
                        </ul>
                    </div>
                </van-col>
                <div v-if="mockHcInfo.TradeRule == '0'">
                    <van-col span="24" class="showParameterAll_animation" style="position: relative;" >
                        <div class="li">
                            <p class="par-classify">风控 I</p>

                            <ul class="par-ul">
                                <li class="par-ul_li">
                                    <p class="par-ul_label">仓位</p>

                                    <p class="par-ul_content">满仓</p>
                                </li>

                                <li class="par-ul_li">
                                    <p class="par-ul_label">止盈</p>

                                    <p class="par-ul_content">
                                        收益率 ≥ {{ (mockHcInfo.stopProfitHigh * 100).toFixed(2) || '--' }}% 时回落{{
                                            (mockHcInfo.stopProfitLow * 100).toFixed(2) || '--'
                                        }}%
                                    </p>
                                </li>

                                <li class="par-ul_li">
                                    <p class="par-ul_label">止损</p>

                                    <p class="par-ul_content">
                                        收益率 ≤ {{ (mockHcInfo.stopLoss * 100).toFixed(2) || '--' }}%
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <!-- 标签 -->
                        <span class="tag-info">普通规则交易</span>
                    </van-col>
                </div>
                <div v-else>
                    <van-col span="24" class="showParameterAll_animation" style="position: relative;" >
                        <div class="li-list">
                            <p class="par-classify">风控 I</p>
                            <div class="sc-list">
                                <p class="tag-title-text">强势<br />市场</p>
                                <ul class="par-ul">
                                    <li class="par-ul_li">
                                        <p class="par-ul_label">仓位</p>

                                        <p class="par-ul_content">
                                            {{ (mockHcInfo.MightyRiskPosition * 100).toFixed(2) || '--' }}%
                                        </p>
                                    </li>

                                    <li class="par-ul_li">
                                        <p class="par-ul_label">止盈</p>

                                        <p class="par-ul_content">
                                            收益率 ≥
                                            {{ (mockHcInfo.MightyStopProfitHigh * 100).toFixed(2) || '--' }}%
                                            时回落{{ (mockHcInfo.MightyStopProfitLow * 100).toFixed(2) || '--' }}%
                                        </p>
                                    </li>

                                    <li class="par-ul_li">
                                        <p class="par-ul_label">止损</p>

                                        <p class="par-ul_content">
                                            收益率 ≤ {{ (mockHcInfo.MightyStopLoss * 100).toFixed(2) || '--' }}%
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="sc-list">
                                <p class="tag-title-text">弱势<br />市场</p>

                                <ul class="par-ul">
                                    <li class="par-ul_li">
                                        <p class="par-ul_label">仓位</p>

                                        <p class="par-ul_content">
                                            {{ (mockHcInfo.WeaknessRiskPosition * 100).toFixed(2) || '--' }}%
                                        </p>
                                    </li>

                                    <li class="par-ul_li">
                                        <p class="par-ul_label">止盈</p>

                                        <p class="par-ul_content">
                                            收益率 ≥
                                            {{ (mockHcInfo.WeaknessStopProfitHigh * 100).toFixed(2) || '--' }}%
                                            时回落{{
                                                (mockHcInfo.WeaknessStopProfitLow * 100).toFixed(2) || '--'
                                            }}%
                                        </p>
                                    </li>

                                    <li class="par-ul_li">
                                        <p class="par-ul_label">止损</p>

                                        <p class="par-ul_content">
                                            收益率 ≤ {{ (mockHcInfo.WeaknessStopLoss * 100).toFixed(2) || '--' }}%
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="sc-list">
                                <p class="tag-title-text">震荡<br />市场</p>

                                <ul class="par-ul">
                                    <li class="par-ul_li">
                                        <p class="par-ul_label">仓位</p>

                                        <p class="par-ul_content">
                                            {{ (mockHcInfo.VibrateRiskPosition * 100).toFixed(2) || '--' }}%
                                        </p>
                                    </li>

                                    <li class="par-ul_li">
                                        <p class="par-ul_label">止盈</p>

                                        <p class="par-ul_content">
                                            收益率 ≥
                                            {{ (mockHcInfo.VibrateStopProfitHigh * 100).toFixed(2) || '--' }}%
                                            时回落{{ (mockHcInfo.VibrateStopProfitLow * 100).toFixed(2) || '--' }}%
                                        </p>
                                    </li>

                                    <li class="par-ul_li">
                                        <p class="par-ul_label">止损</p>

                                        <p class="par-ul_content">
                                            收益率 ≤ {{ (mockHcInfo.VibrateStopLoss * 100).toFixed(2) || '--' }}%
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- 标签 -->
                        <span class="tag-info" @click="viewIntroduction = true">大盘择时交易-{{
                            isTemplateInfo(mockHcInfo.RiskTemplate) }}
                            <img class="tag-info-img" src="../../assets/image/help.png" alt="" /></span>
                    </van-col>
                </div>
            </van-row>
        </div>
    </div>
</template>


<script>
import { judgeColor, toFixedNum, formatStrTime } from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  name: 'Home',
  mixins: [mixin],
  props: ['mockHcInfo','datailObj'],
  data() {
    return {

    };
  },
  filters: {},
  created() {},
  watch: {},
  mounted() {
    console.log('this.mockHcInfo',this.mockHcInfo)
    console.log('this.datailObj',this.datailObj)
  },

  methods: {
    judgeColor,
    toFixedNum,
    formatStrTime,
    // 模版文字
    isTemplateInfo: function (num) {
      switch (num) {
        case '0':
          return 'MACD仓控模板';
          break;
        case '1':
          return '均线模板';
          break;
        case '2':
          return '成交额仓控模板';
          break;
        case '3':
          return '乖离仓控模板';
          break;
        case '4':
          return '价格仓控模板';
          break;
        case '5':
          return '价格均线仓控模板';
          break;
        default:
          return '-';
          break;
      }
    },
  }
};
</script>

<style lang="less" scoped>
  .collapse {
    // padding: 0 16px 22px 16px;
    .title {
      font-weight: 700;
      font-size: 14px;
      color: #286df7;
    }
    .yz-list {
      .li {
        height: 34px;
        line-height: 34px;
        border: 1px solid #fff;
        border-radius: 4px;
        background: linear-gradient(to bottom right, #e6edff 10%, #fff 60%);
        padding: 0 12px;
        margin-top: 6px;
        font-weight: 500;
        font-size: 12px;
        color: rgba(55, 58, 77, 0.9);
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        display: -webkit-box;
        -webkit-line-clamp: 1; // 超出多少行
        -webkit-box-orient: vertical;
      }
    }
    .parameter {
      .li {
        display: flex;
        height: auto;
        line-height: normal;
        padding: 10px 12px;
        .par-classify {
          font-size: 14px;
          font-weight: 700;
          background: linear-gradient(90deg, rgba(35, 134, 234, 1), rgba(67, 106, 206, 1));
          -webkit-background-clip: text; /* Safari/Chrome */
          -webkit-text-fill-color: transparent; /* Safari/Chrome */
          background-clip: text; /* 其他浏览器 */
          color: transparent;
          margin-right: 26px;
        }

        .par-ul {
          line-height: 20px;
          flex: 1;
          .par-ul_li {
            display: flex;
            align-items: flex-start;
            .par-ul_label {
              color: #666;
              font-size: 12px;
              font-weight: 400;
              width: 70px;
              flex-shrink: 0;
            }
            .par-ul_content {
              color: rgba(55, 58, 77, 0.9);
              font-size: 12px;
              font-weight: bold;
            }
          }
        }
      }
      // 卖出列表
      .li-list {
        border: 1px solid red;
        padding: 10px 12px;
        border-radius: 4px;
        border: 1px solid #fff;
        background: linear-gradient(to bottom right, #e6edff 10%, #fff 60%);
        margin-top: 6px;
        font-weight: 500;
        font-size: 12px;
        color: rgba(55, 58, 77, 0.9);
        .par-classify {
          font-size: 14px;
          font-weight: 700;
          background: linear-gradient(90deg, rgba(35, 134, 234, 1), rgba(67, 106, 206, 1));
          -webkit-background-clip: text; /* Safari/Chrome */
          -webkit-text-fill-color: transparent; /* Safari/Chrome */
          background-clip: text; /* 其他浏览器 */
          color: transparent;
          margin-right: 26px;
        }
        .sc-list {
          border-radius: 6px;
          background: #f7f7fc;
          padding: 8px 12px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-content: center;
          justify-content: flex-start;
          margin-top: 8px;
          .tag-title-text {
            width: 60px;
            font-size: 12px;
            font-weight: 700;
            background: linear-gradient(90deg, rgba(35, 134, 234, 1), rgba(67, 106, 206, 1));
            -webkit-background-clip: text; /* Safari/Chrome */
            -webkit-text-fill-color: transparent; /* Safari/Chrome */
            background-clip: text; /* 其他浏览器 */
            color: transparent;
          }
          .par-ul {
            line-height: 20px;
            .par-ul_li {
              display: flex;
              // align-items: center;
              .par-ul_label {
                color: #666;
                font-size: 12px;
                font-weight: 400;
                width: 80px;
                flex-shrink: 0;
              }
              .par-ul_content {
                color: rgba(55, 58, 77, 0.9);
                font-size: 12px;
                font-weight: bold;
              }
            }
          }
        }
      }
      .tag-info {
        position: absolute;
        top: 6px;
        right: 0;
        padding: 2px 6px;
        border-radius: 0px 6px;
        background: linear-gradient(270deg, #4276ff 0%, #8dabff 100%);
        font-size: 12px;
        color: #fff;
        font-weight: 400;
        display: flex;
        align-content: center;
        align-items: center;
        .tag-info-img {
          width: 12px;
          height: 12px;
          display: inline-block;
          margin-left: 6px;
        }
      }
    }
  }


  .black_version {

      .collapse {
    .title {
      color: #3b85fe;
    }
    .yz-list {
      .li {
        border: 1px solid rgba(255, 255, 255, 0.1);;
        background: rgba(255, 255, 255, 0.1);
        color: #e4e9fe;
      }
    }
    .parameter {
      .li {
        .par-classify {
          // background: linear-gradient(90deg, rgba(35, 134, 234, 1), rgba(67, 106, 206, 1));
        }

        .par-ul {
          .par-ul_li {
            .par-ul_label {
              color: #aab9d1;
            }
            .par-ul_content {
              color: #e4e9fe;
            }
          }
        }
      }
      // 卖出列表
      .li-list {
        border: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(255, 255, 255, 0.1);
        color: rgba(55, 58, 77, 0.9);

        .sc-list {
          background: rgba(255, 255, 255, 0.1);

          .par-ul {
            .par-ul_li {
              .par-ul_label {
                 color: #aab9d1;
              }
              .par-ul_content {
               color: #e4e9fe;
              }
            }
          }
        }
      }
      .tag-info {
        background: linear-gradient(270deg, #4276ff 0%, #8dabff 100%);
        color: #fff;
      }
    }
  }
  }
</style>
